import React from "react";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Box,
  SxProps,
} from "@mui/material";

type CardKitProps = {
  title?: React.ReactNode;
  subtitle?: string;
  description?: string;
  word?: string;
  children?: React.ReactNode;
  width?: number | string;
  height?: number | string;
  sx?: SxProps;
  className?: string;
};
/**

* CardKit
*
* یک کامپوننت کارت عمومی که امکان نمایش عنوان، متن تزئینی (word)،
* و ناحیه اکشن‌ها (children) را فراهم می‌کند. این کارت با استفاده از
* کامپوننت‌های MUI ساخته شده و قابلیت سفارشی‌سازی اندازه و استایل را دارد.
*
* ویژگی‌ها:
* * نمایش عنوان کارت در بخش CardContent
* * نمایش متن word با جداکننده نقطه‌ای میان حروف
* * نمایش children در بخش CardActions
* * امکان تعیین width و height برای کارت
* * پشتیبانی از sx برای اعمال استایل سفارشی
*
* Props:
* @property {React.ReactNode} [title] عنوان کارت
* @property {string} [word] رشته‌ای که به صورت جداشده با علامت • نمایش داده می‌شود
* @property {React.ReactNode} [children] محتوای بخش اکشن‌ها (CardActions)
* @property {number | string} [width] عرض کارت
* @property {number | string} [height] ارتفاع کارت
* @property {SxProps} [sx] استایل سفارشی برای کارت
* @property {String} [className] کلاس
* @returns JSX.Element
  */

const CardKit: React.FC<CardKitProps> = ({
  title,
  word,
  children: actions,
  width,
  height,
  sx,
  className,
}) => {
  const bull = (
    <Box
      component="span"
      sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
    >
      •
    </Box>
  );

  return (
    <Card
      className={`${className}`}
      sx={{
        boxShadow: "none !important",
        width,
        height,
        overflow: "hidden",
        borderRadius: "12px",
        ...sx,
        minWidth: "100%",
        padding: "10px",
      }}
    >
      {title && (
        <CardContent sx={{ width: "100%" }}>
          {title}
          {word && (
            <Typography variant="h5" component="div">
              {word.split("").map((char, index) => (
                <React.Fragment key={index}>
                  {char}
                  {index !== word.length - 1 && bull}
                </React.Fragment>
              ))}
            </Typography>
          )}
        </CardContent>
      )}

      {actions && <CardActions>{actions}</CardActions>}
    </Card>
  );
};

export default CardKit;
